const CustomPreparedHeaderCell = (
    {
        rowType,
        column,
        cellElement
    }
) => {
    const black = '#000000';
    const medium = '600';

    if (rowType === "header") {
        if (cellElement && cellElement.style) {
            cellElement.style.cssText = `color: ${black}; font-weight: ${medium}`;
        }

        if (column?.caption && cellElement) {
            const caption = column.caption;
            cellElement.setAttribute("role", "button");
            cellElement.setAttribute("aria-label", `Sort by ${caption}`);
            if (!cellElement.hasAttribute("aria-sort")) {
                cellElement.setAttribute("aria-sort", "none");
            }
            if (!cellElement.hasAttribute("tabindex")) {
                cellElement.setAttribute("tabindex", "0");
            }
        }
    }

    if ((rowType === "filter" || rowType === "filterRow") && column?.caption && cellElement) {
        const caption = column.caption;
        const ariaLabel = `Search ${caption}`;

        const searchElements = cellElement.querySelectorAll('[aria-label="Search box"], [aria-label="search box"], [role="menuitem"]');
        searchElements.forEach((element) => {
            element.setAttribute("aria-label", ariaLabel);
            if (!element.hasAttribute("role")) {
                element.setAttribute("role", "button");
            }
        });

        const inputElement = cellElement.querySelector('input');
        if (inputElement && !inputElement.getAttribute('aria-label')) {
            inputElement.setAttribute('aria-label', `${caption} filter`);
        }
    }
};

export default CustomPreparedHeaderCell;
